import slice from "./suggestedNewLocationsSlice";

export default slice.reducer;
